<template>
  <div class="row" :style="{height: windowHeight - pageTopHeight - 60 + 'px'}">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('settingsPages.companyLocations')"></general-top-bar> -->
      <!--End General Top Bar -->
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="pull-left mar-bt-20">
            <el-input v-model="searchQuery" :placeholder="$t('reports.search')" class="icon-search"></el-input>
          </div>
          <div class="pull-right">
            <button class="btn add" @click.prevent="goToAdd" :title="$t('general.add')">
              <img src="/static/img/icons/add.png">
              {{$t('general.add')}}
            </button>
          </div>
          <data-tables
            v-loading="loading"
            :data="filteredData"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :table-props="{'border': false}"
            style="width: 100%">

            <el-table-column
              min-width="20"
              prop="true_id"
              label="ID">
            </el-table-column>

            <el-table-column
              min-width="100"
              prop="name"
              :label="$t('settingCompany.name')">
            </el-table-column>

            <el-table-column
              min-width="100"
              prop="street"
              :label="$t('settingCompany.street')">
            </el-table-column>

            <el-table-column
              min-width="100"
              prop="email"
              :label="$t('settingCompany.email')">
              <template slot-scope="props">
                <div class="break-word">{{ props.row.email}}</div>
              </template>
            </el-table-column>

            <el-table-column
              min-width="50"
              prop="phone"
              :label="$t('settingCompany.phone')">
            </el-table-column>

            <el-table-column
              min-width="40"
              prop="active"
              :label="$t('settingLocationGroups.active')">
              <template slot-scope="props">
                <p-switch v-model="props.row.active" type="success" @input="handleActive(props.$index, props.row, $event)"></p-switch>
              </template>
            </el-table-column>

            <el-table-column
              min-width="40"
              prop="is_open"
              :label="$t('settingLocationGroups.isOpen')">
              <template slot-scope="props">
                <p-switch v-model="props.row.is_open" type="success" @input="handleIsOpen(props.$index, props.row, $event)"></p-switch>
              </template>
            </el-table-column>

            <!-- <div class="form-group">
              <p-switch v-model="model.active" type="success"></p-switch>
              <label>{{$t('settingLocationGroups.active')}}</label>
            </div> -->

            <el-table-column
              :width="300"
              :label="$t('marketingOffers.actions')">
              <template slot-scope="props">
                <a
                  class="btn delete mar-rt-10"
                  :title="$t('general.delete')"
                  @click="handleDelete(props.row.id, props.row.true_id)">
                  <img src="/static/img/icons/icon-close.png">
                  {{$t('general.delete')}}
                </a>
                <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'

export default {
  components: {
    // GeneralTopBar,
    PSwitch
  },
  created () {
    this.initData()

    this.$bus.$on('refresh', this.handleRefresh)
  },
  mounted () {
    this.$nextTick(() => {
      this.doHeightCalculation()
      this.loading = true

      window.addEventListener('resize', () => {
        this.doHeightCalculation()
      })

      // this.$bus.$on('refresh', this.handleRefresh)
    })
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  data () {
    return {
      loading: true,
      isNew: false,
      showLocations: false,
      locations: [],
      model: [],
      searchQuery: '',
      windowHeight: 0,
      pageTopHeight: 76,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 25, 50]
      }
    }
  },
  computed: {
    filteredData () {
      const query = this.searchQuery.toLowerCase()
      return this.model.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        )
      })
    }
  },
  methods: {
    handleRefresh () {
      this.initData()
    },
    initData () {
      this.loading = true
      this.getLocations()

      const companyData = this.$session.get('selectedCompanyData')
      if (companyData && companyData.locations_details) {
        this.locations = companyData.locations_details
      }
    },
    handleActive (index, row, event) {
      if (event) {
        swal({
          text: this.$t('settingCompany.activateLocationCost'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.cancel2')
        })
        .then((result) => {
          if (result) {
            this.updateLocationStatus(row)
          }
        }).catch(() => {
          this.model[index].active = !event
        })
      } else {
        this.updateLocationStatus(row)
      }
    },
    handleIsOpen (index, row, event) {
      this.updateLocationIsOpen(row, () => {
        this.model[index].is_open = !event
      })
    },
    doHeightCalculation () {
      this.windowHeight = window.innerHeight
    },
    updateLocationStatus (location) {
      this.loading = true

      let data = {
        token: this.$session.get('token'),
        company_id: location.company_id,
        location_id: location.true_id,
        location_token: location.token,
        active: location.active
      }

      this.apiRequest('/locations/' + location.true_id + '/active', 'PUT', data, response => {
        if (response.status) {
          this.trackAdminEvent('ADMIN_LOCATION_UPDATE', 'location', location.true_id, {
            location_id: location.true_id,
            name: location.name || null,
            active: !!location.active
          })
          swal({
            text: 'Sucess!',
            type: 'success',
            showConfirmButton: false,
            timer: 1000
          })
        } else {
          swal({
            text: 'Error!',
            type: 'error',
            showConfirmButton: false,
            timer: 1000
          })
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateLocationIsOpen (location, onError) {
      this.loading = true

      let data = {
        token: this.$session.get('token'),
        company_id: location.company_id,
        location_id: location.true_id,
        location_token: location.token,
        is_open: location.is_open
      }

      this.apiRequest('/locations/' + location.true_id + '/is-open', 'PUT', data, response => {
        if (response.status) {
          swal({
            text: 'Sucess!',
            type: 'success',
            showConfirmButton: false,
            timer: 1000
          })
        } else {
          if (typeof onError === 'function') onError()
          swal({
            text: 'Error!',
            type: 'error',
            showConfirmButton: false,
            timer: 1000
          })
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    goToRecord (row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.true_id)
      } else {
        row.id = row.true_id
        this.globalGoToRecord(row, event, column, '/locations/edit/')
      }
    },
    goToAdd () {
      swal({
        text: this.$t('settingCompany.createLocationCost'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      })
      .then((result) => {
        if (result) {
          this.$session.set('selecetdTab', 'Company Details')
          this.$router.push('/locations/add')
        }
      })
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getLocations () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        columns: ['id', 'token', 'company_id', 'name', 'email', 'street', 'phone', 'active', 'is_open']
      }

      this.apiRequest('/locations', 'GET', data, response => {
        if (response.status) {
          this.model = (response.data || []).map(loc => ({
            ...loc,
            is_open: loc.is_open === undefined || loc.is_open === null ? true : !!loc.is_open
          }))
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    saveDetails () {
      var companyID = this.$session.get('selectedCompany')
      var data = {
        'token': this.$session.get('token'),
        'fidelities_labels_primary_option': this.labelsPrimaryOption,
        'enable_label_notification': this.enableLabelNotification,
        'fidelities_labels_interval': this.labelsInterval,
        'show_userlabel': this.showLabel
      }

      var self = this
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          swal({'text': self.$t('marketingFidelities.labelingSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 1000}).catch(() => {})
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]))
        } else {
          self.handleErrors(response.errors)
          // swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 1000})
        }
      })
    },
    handleDelete (id, trueId) {
      var btnCounter = 3
      var self = this
      var companyID = this.$session.get('selectedCompany')

      var data = {
        token: this.$session.get('token'),
        company_id: companyID,
        location_id: id,
        true_id: trueId
      }

      this.apiRequest('/settings/can-delete-location', 'POST', data, (response) => {
        if (response.status === true) {
          // location ca be deleted
          swal({
            text: self.$t('settingCompany.areYouSureDelete'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes (' + btnCounter + ')'
          })
          .then((result) => {
            if (result) {
              this.loading = true
              self.apiRequest('admin/location/' + trueId, 'DELETE', data, (response) => {
                if (response.status) {
                  const loc = (self.model || []).find(l => l.true_id === trueId || l.id === id) || {}
                  self.trackAdminEvent('ADMIN_LOCATION_DELETED', 'location', trueId, {
                    location_id: trueId,
                    name: loc.name || null
                  })
                  this.getLocations()
                  this.loading = false
                  swal({
                    text: 'Sucess!',
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1000
                  })
                }
              })
            }
          })
          swal.disableConfirmButton()

          var btnInterval = setInterval(function () {
            btnCounter--

            if (btnCounter >= 1) {
              swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
            } else {
              swal.getConfirmButton().textContent = 'Yes'
              clearInterval(btnInterval)
              swal.enableConfirmButton()
            }
          }, 1000)
        } else if (response.status === false && response.errors.location_ids !== undefined) {
          swal({'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error'}).catch(() => {})
        } else {
          swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
        }
      })
    },
    validate () {
      this.errors['items'] = this.removeErrorByName('error', this.errors['items'])
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.handleCreate()
        } else {
          // console.info('is not valid', this.errors)
        }
      })
    },
    checkValueOrNumber (item) {
      if (item) {
        item.showError = false
      } else {
        this.model.showError = false
      }
    }
  }
}
</script>

<style>
  td.error-spelling-fix-position textarea.label-notification-textarea {
    resize: vertical !important;
    overflow: hidden !important;
    min-height: auto !important;
  }

  .delivery_method{
    display: flex;
    flex-direction: column;
  }
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }

  .loyaltyPointsModal__footer {
    text-align: end;
  }

  .loyaltyModal {
    text-align: center;
  }

  .break-word {
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Locations/Location.vue